var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "report-agent-performance" } }, [
    _c("div", { staticClass: "overall-content" }, [
      _c(
        "div",
        { staticClass: "chart-container" },
        [
          _c(
            "div",
            { staticClass: "chart-section" },
            [
              _c(
                "div",
                { staticClass: "title" },
                [
                  _c("ChartDoddleIcon"),
                  _vm._v(" "),
                  _c("h2", [
                    _vm._v(_vm._s(_vm.$t("report.agentWorkTimeCalendar"))),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c("WorkTimeCalendar", {
                attrs: {
                  title: _vm.$t("report.agentWorkTimeCalendar"),
                  filters: _vm.filters,
                  loading: _vm.loading,
                  data: _vm.data,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("a-divider"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "chart-section" },
            [
              _c(
                "div",
                { staticClass: "title" },
                [
                  _c("ChartDoddleIcon"),
                  _vm._v(" "),
                  _c("h2", [_vm._v(_vm._s(_vm.$t("report.agentBreakTime")))]),
                ],
                1
              ),
              _vm._v(" "),
              _c("BreakCount", {
                attrs: {
                  title: _vm.$t("report.agentBreakTime"),
                  filters: _vm.filters,
                  loading: _vm.loading,
                  data: _vm.data,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("a-divider"),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }